import { get, post, del } from '@/lib/api/client'
import {
  type Comment,
  type CommentCreate,
  type ApiResponse,
  CommentCreateSchema
} from '@/lib/api/types'

export class PressReleaseCommentService {
  /**
   * Get all comments for a press release
   * GET /press-release-comments/public/all/{pressReleaseId}
   */
  async getComments(pressReleaseId: string): Promise<ApiResponse<Comment[]>> {
    return await get<ApiResponse<Comment[]>>(
      `press-release-comments/public/all/${pressReleaseId}`
    )
  }

  /**
   * Add a comment to a press release
   * POST /press-release-comments/public/addcomment/{pressReleaseId}
   */
  async addComment(
    pressReleaseId: string,
    data: CommentCreate
  ): Promise<ApiResponse<Comment>> {
    const validatedData = CommentCreateSchema.parse(data)
    return await post<ApiResponse<Comment>>(
      `press-release-comments/public/addcomment/${pressReleaseId}`,
      validatedData
    )
  }

  /**
   * Delete a reply
   * DELETE /press-release-replies/public/reply/{replyId}
   */
  async deleteReply(replyId: string): Promise<ApiResponse<void>> {
    return await del<ApiResponse<void>>(
      `press-release-replies/public/reply/${replyId}`
    )
  }

  /**
   * Delete a comment and all its replies
   * DELETE /press-release-replies/public/comments/{commentId}/replies
   */
  async deleteComment(commentId: string): Promise<ApiResponse<void>> {
    return await del<ApiResponse<void>>(
      `press-release-replies/public/comments/${commentId}/replies`
    )
  }
}

// Export singleton instance
export const pressReleaseCommentService = new PressReleaseCommentService()

// Export default
export default pressReleaseCommentService

